import { FUNCTIONAL_ELEMENT_TYPE, FunctionalElement } from './functional-element';

export type ExchangeableComponent = Readonly<{
    componentXmlId: string;
    label: string;
    matNo: string;
    matNoLabel: string;
    matNoXmlId: string;
    serialNo: string;
    serialNoLabel: string;
    serialNoXmlId: string;
}>;

export const initialExchangeableComponentState: ExchangeableComponent = {
    componentXmlId: '',
    label: '',
    matNo: '',
    matNoLabel: '',
    matNoXmlId: '',
    serialNo: '',
    serialNoLabel: '',
    serialNoXmlId: '',
};

export type DefectiveComponentReplacement = Readonly<{
    description: string;
    type: FUNCTIONAL_ELEMENT_TYPE.DEFECTIVE_COMPONENT_REPLACEMENT;
    swapOutComponent: ExchangeableComponent;
    swapInComponent: ExchangeableComponent;
    repairTimeLabel: string;
    repairTime: string;
    repairTimeXmlId: string;
}> &
    FunctionalElement;

export const initialDefectiveComponentReplacementState: DefectiveComponentReplacement = {
    id: -1,
    description: '',
    swapInComponent: initialExchangeableComponentState,
    swapOutComponent: initialExchangeableComponentState,
    repairTime: '',
    repairTimeLabel: '',
    repairTimeXmlId: '',
    parentId: -1,
    type: FUNCTIONAL_ELEMENT_TYPE.DEFECTIVE_COMPONENT_REPLACEMENT,
    controllingCheckpoint: '',
    contentLoadedFromXml: false,
    disabled: false,
    controllingOption: undefined,
    uniqueId: undefined,
};

export function isDefectiveComponentReplacement(f: FunctionalElement): f is DefectiveComponentReplacement {
    return f.type === FUNCTIONAL_ELEMENT_TYPE.DEFECTIVE_COMPONENT_REPLACEMENT;
}
